export enum DependencyEnum {
  NoDependency = 'NoDependency',
  Inferior50 = 'Inferior50',
  Inferior99 = 'Inferior99',
  Superior100 = 'Superior100',
  Superior250 = 'Superior250'
}
